/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  EntityId,
  List,
  SiteChannelType,
  SiteQuestion,
  SiteQuestionAnswer,
  SiteQuestionAnswerHelpfulness,
  SiteQuestionAnswerRelevance,
  SiteQuestionAnswerResolution,
  SiteQuestionAnswerSource,
  SiteQuestionAnswerWithResponse,
  SiteQuestionStats,
  SiteQuestionTimeline,
  SiteQuestionTimelineInterval,
  SiteQuestionType,
  SiteQuestionVisitorType,
  Timestamp,
} from "./data-contracts";

/**
 * @description Returns a paginated list of the questions visitors asked a site's Ask AI assistant, each with usage stats. Use it to discover what users are looking for and where the documentation has gaps.
 * @tags site-questions
 * @name ListSiteQuestions
 * @summary List the questions visitors asked a site's Ask AI assistant
 * @request GET:/orgs/{organizationId}/sites/{siteId}/questions
 * @secure
 */

// @ts-ignore
export const listSiteQuestions: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** Filter stats to answers created at or after this timestamp. */
    from?: Timestamp;
    /** Filter stats to answers created at or before this timestamp. */
    to?: Timestamp;
    /** Filter questions by question type. */
    type?: SiteQuestionType;
    /** Filter questions by question relevance. */
    relevance?: SiteQuestionAnswerRelevance[];
    /** Filter questions by answer channel type. */
    channelType?: SiteChannelType[];
    /** Filter by whether a person or an AI agent asked the question. */
    visitorType?: SiteQuestionVisitorType[];
    /** Filter questions by answer resolution. */
    answered?: SiteQuestionAnswerResolution[];
    /** Filter questions by associated site topic IDs. */
    topic?: string[];
    /**
     * An order for the items in the list
     * @default "desc"
     */
    order?: "asc" | "desc";
    /** Sort questions by latest ask activity, answered rate, or positive feedback rate. If omitted, ordering stays on canonical question creation date to preserve current behavior. */
    sort?: "askedAt" | "stats.answered" | "stats.feedback" | "stats.answers";
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: SiteQuestion[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/questions",
  method: "get",
  streaming: false,
  tags: ["site-questions"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Retrieves one question asked to a site's Ask AI assistant, including its canonical text and aggregate stats. Use it to inspect a specific question discovered via listSiteQuestions.
 * @tags site-questions
 * @name GetSiteQuestionById
 * @summary Get a single Ask AI question by ID
 * @request GET:/orgs/{organizationId}/sites/{siteId}/questions/{siteQuestionId}
 * @secure
 */

// @ts-ignore
export const getSiteQuestionById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the site question */
    siteQuestionId: string;
  };
  RequestQuery: {
    /** Filter stats to answers created at or after this timestamp. */
    from?: Timestamp;
    /** Filter stats to answers created at or before this timestamp. */
    to?: Timestamp;
    /** Filter stats by question relevance. */
    relevance?: SiteQuestionAnswerRelevance[];
    /** Filter stats by answer channel type. */
    channelType?: SiteChannelType[];
    /** Filter by whether a person or an AI agent asked the question. */
    visitorType?: SiteQuestionVisitorType[];
    /** Filter stats by answer resolution. */
    answered?: SiteQuestionAnswerResolution[];
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: SiteQuestion;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/questions/{siteQuestionId}",
  method: "get",
  streaming: false,
  tags: ["site-questions"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns the documentation pages the Ask AI assistant used to answer a given question. Use it to see which content grounded the AI's responses to that question.
 * @tags site-questions
 * @name ListSiteQuestionSources
 * @summary List the documentation sources used to answer a question
 * @request GET:/orgs/{organizationId}/sites/{siteId}/questions/{siteQuestionId}/sources
 * @secure
 */

// @ts-ignore
export const listSiteQuestionSources: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the site question */
    siteQuestionId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /** Filter sources to answers created at or after this timestamp. */
    from?: Timestamp;
    /** Filter sources to answers created at or before this timestamp. */
    to?: Timestamp;
    /** Filter answer sources by question relevance. */
    relevance?: SiteQuestionAnswerRelevance[];
    /** Filter answer sources by answer channel type. */
    channelType?: SiteChannelType[];
    /** Filter by whether a person or an AI agent asked the question. */
    visitorType?: SiteQuestionVisitorType[];
    /** Filter answer sources by answer resolution. */
    answered?: SiteQuestionAnswerResolution[];
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: SiteQuestionAnswerSource[];
  };
  ResponseStatusCode: 200;
} = {
  route:
    "/orgs/{organizationId}/sites/{siteId}/questions/{siteQuestionId}/sources",
  method: "get",
  streaming: false,
  tags: ["site-questions"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns aggregate statistics about the questions visitors asked a site's Ask AI assistant over a time range, optionally filtered by topic, relevance, or channel.  Use it for a high-level view of AI-assistant usage before drilling into individual questions.
 * @tags site-questions
 * @name GetSiteQuestionStats
 * @summary Get aggregate Ask AI question statistics for a site
 * @request GET:/orgs/{organizationId}/sites/{siteId}/question-stats
 * @secure
 */

// @ts-ignore
export const getSiteQuestionStats: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** Filter stats to answers created at or after this timestamp. */
    from?: Timestamp;
    /** Filter stats to answers created at or before this timestamp. */
    to?: Timestamp;
    /** Filter stats by associated site topic IDs. */
    topic?: string[];
    /** Filter stats by question relevance. */
    relevance?: SiteQuestionAnswerRelevance[];
    /** Filter stats by answer channel type. */
    channelType?: SiteChannelType[];
    /** Filter by whether a person or an AI agent asked the question. */
    visitorType?: SiteQuestionVisitorType[];
    /** Filter stats by answer resolution. */
    answered?: SiteQuestionAnswerResolution[];
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: SiteQuestionStats;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/question-stats",
  method: "get",
  streaming: false,
  tags: ["site-questions"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns how many answers the site's Ask AI assistant gave, and to how many visitors, in each UTC bucket of the interval between `from` and `to`, optionally filtered by topic, relevance, channel, visitor type or resolution. Buckets without answers are omitted.
 * @tags site-questions
 * @name GetSiteQuestionTimeline
 * @summary Get Ask AI answers over time for a site
 * @request GET:/orgs/{organizationId}/sites/{siteId}/question-timeline
 * @secure
 */

// @ts-ignore
export const getSiteQuestionTimeline: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** Count answers created at or after this timestamp. */
    from: Timestamp;
    /** Count answers created at or before this timestamp. */
    to: Timestamp;
    /** Size of each bucket. An hourly timeline covers at most 31 days. */
    interval: SiteQuestionTimelineInterval;
    /** Filter answers by associated site topic IDs. */
    topic?: string[];
    /** Filter answers by question relevance. */
    relevance?: SiteQuestionAnswerRelevance[];
    /** Filter answers by channel type. */
    channelType?: SiteChannelType[];
    /** Filter by whether a person or an AI agent asked the question. */
    visitorType?: SiteQuestionVisitorType[];
    /** Filter answers by resolution. */
    answered?: SiteQuestionAnswerResolution[];
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: SiteQuestionTimeline;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/question-timeline",
  method: "get",
  streaming: false,
  tags: ["site-questions"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns a paginated list of individual Ask AI answers generated for a site. Each is the assistant's response to a specific asked question, with the raw question text, channel, and feedback. Use it to review answer quality and what users asked across the site.
 * @tags site-questions
 * @name ListSiteQuestionAnswers
 * @summary List the answers a site's Ask AI assistant generated
 * @request GET:/orgs/{organizationId}/sites/{siteId}/answers
 * @secure
 */

// @ts-ignore
export const listSiteQuestionAnswers: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** Filter answers to a specific site question ID. */
    question?: string;
    /** Filter answers created at or after this timestamp. */
    from?: Timestamp;
    /** Filter answers created at or before this timestamp. */
    to?: Timestamp;
    /** Filter answers by ISO language code. */
    language?: string;
    /** Filter answers by answered resolution. */
    answered?: SiteQuestionAnswerResolution[];
    /** Filter answers by answered helpfulness. */
    helpfulness?: SiteQuestionAnswerHelpfulness;
    /** Filter answers by question relevance. */
    relevance?: SiteQuestionAnswerRelevance[];
    /** Filter answers by answer channel type. */
    channelType?: SiteChannelType[];
    /** Filter by whether a person or an AI agent asked the question. */
    visitorType?: SiteQuestionVisitorType[];
    /** Filter answers by question type. */
    "question.type"?: SiteQuestionType;
    /** Filter answers by associated site topic ID. */
    topic?: string;
    /** Filter answers by thread root answer ID. Includes the root answer itself. */
    thread?: string;
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: SiteQuestionAnswer[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/answers",
  method: "get",
  streaming: false,
  tags: ["site-questions"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Retrieves one Ask AI answer, including the question that prompted it, the response, and its feedback. Use it to inspect a specific answer discovered via listSiteQuestionAnswers.
 * @tags site-questions
 * @name GetSiteQuestionAnswerById
 * @summary Get a single Ask AI answer by ID
 * @request GET:/orgs/{organizationId}/sites/{siteId}/answers/{siteQuestionAnswerId}
 * @secure
 */

// @ts-ignore
export const getSiteQuestionAnswerById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the site question answer */
    siteQuestionAnswerId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: SiteQuestionAnswerWithResponse;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/answers/{siteQuestionAnswerId}",
  method: "get",
  streaming: false,
  tags: ["site-questions"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns the full conversation thread for a given Ask AI answer: the sequence of follow-up questions and responses in that exchange.
 * @tags site-questions
 * @name GetSiteQuestionAnswerThreadById
 * @summary Get the conversation thread for an Ask AI answer
 * @request GET:/orgs/{organizationId}/sites/{siteId}/answers/{siteQuestionAnswerId}/thread
 * @secure
 */

// @ts-ignore
export const getSiteQuestionAnswerThreadById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the site question answer */
    siteQuestionAnswerId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: SiteQuestionAnswerWithResponse[];
  ResponseStatusCode: 200;
} = {
  route:
    "/orgs/{organizationId}/sites/{siteId}/answers/{siteQuestionAnswerId}/thread",
  method: "get",
  streaming: false,
  tags: ["site-questions"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns the documentation pages the Ask AI assistant cited to produce a given answer. Use it to see exactly which content grounded that specific answer.
 * @tags site-questions
 * @name ListSiteQuestionAnswerSources
 * @summary List the documentation sources cited for an answer
 * @request GET:/orgs/{organizationId}/sites/{siteId}/answers/{siteQuestionAnswerId}/sources
 * @secure
 */

// @ts-ignore
export const listSiteQuestionAnswerSources: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the site question answer */
    siteQuestionAnswerId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: SiteQuestionAnswerSource[];
  };
  ResponseStatusCode: 200;
} = {
  route:
    "/orgs/{organizationId}/sites/{siteId}/answers/{siteQuestionAnswerId}/sources",
  method: "get",
  streaming: false,
  tags: ["site-questions"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
